import { Injectable } from '@angular/core';
import { CanActivate, Router } from "@angular/router";
import { Observable } from 'rxjs';
import { promise } from 'protractor';
import * as firebase from "firebase";
import { AuthService } from "./auth.service";


@Injectable({
  providedIn: 'root'
})
export class AdminGuardService {
  constructor(private router: Router,
              private authService : AuthService) { }

  admin : any;

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return new Promise(
      (resolve, reject)=> {
        firebase.auth().onAuthStateChanged(
          (user)=> {
            if(user){
              this.authService.isAdmin().then((name)=>{
                 this.admin = name 
                 if(this.admin == true){
                  resolve(true);
                 }else{
                  this.admin = false;
                  this.router.navigate(['home']);
                }
                })
            }else{
              this.admin = false;
              this.router.navigate(['home']);
            }
          }
        )
      }
    )
  }
}
